<div *ngIf="uiState$ | async as ui">
  <div class="mb-6 flex justify-content-end">
    <button pButton type="button" [label]="'INVITE' | translate" icon="pi pi-plus"
      (click)="openAddInviteDialog()"></button>
  </div>

  <p-dialog header="{{ 'ADD_NEW_INVITE' | translate }}" [(visible)]="showAddInviteDialog" [modal]="true"
    [style]="{width: '50vw'}" [draggable]="false" [resizable]="false" [appendTo]="'body'" [baseZIndex]="10000"
    (onHide)="closeAddInviteDialog()">
    <ng-container *ngIf="ui?.addInviteForm">
      <form [formGroup]="ui.addInviteForm" (ngSubmit)="onAddInvite(ui.addInviteForm)" class="grid gap-4 pt-3">
        <div class="col-12 md:col-6">
          <label for="email" class="block text-sm font-medium text-gray-700 mb-1">{{ 'EMAIL_ADDRESS' | translate
            }}</label>
          <input id="email" type="email" pInputText formControlName="email" class="w-full"
            placeholder="user@example.com" />
          <small
            *ngIf="ui.addInviteForm.get('email')?.invalid && (ui.addInviteForm.get('email')?.dirty || ui.addInviteForm.get('email')?.touched)"
            class="p-error block mt-1">
            <span *ngIf="ui.addInviteForm.get('email')?.errors?.['required']">{{ 'EMAIL_REQUIRED' | translate }}</span>
            <span *ngIf="ui.addInviteForm.get('email')?.errors?.['email']">{{ 'INVALID_EMAIL_FORMAT' | translate
              }}</span>
          </small>
        </div>

        <div class="col-12 md:col-4">
          <label for="permission" class="block text-sm font-medium text-gray-700 mb-1">{{ 'PERMISSION' | translate
            }}</label>
          <p-dropdown appendTo="body" id="permission" formControlName="permission_id" [options]="ui.orgLevelPermissions"
            optionLabel="displayName" optionValue="id" [placeholder]="'SELECT_A_PERMISSION' | translate" class="w-full"
            styleClass="w-full"></p-dropdown>
          <small
            *ngIf="ui.addInviteForm.get('permission_id')?.invalid && (ui.addInviteForm.get('permission_id')?.dirty || ui.addInviteForm.get('permission_id')?.touched)"
            class="p-error block mt-1">
            {{ 'PERMISSION_REQUIRED' | translate }}
          </small>
        </div>

        <div class="m-6">
        </div>
      </form>
    </ng-container>
    <ng-template pTemplate="footer">
      <button pButton type="button" [label]="'CANCEL' | translate" class="p-button-text"
        (click)="closeAddInviteDialog()"></button>
      <button pButton type="button" [label]="'SEND_INVITE' | translate" icon="pi pi-send"
        (click)="onAddInvite(ui!.addInviteForm)" [disabled]="ui?.addInviteForm?.invalid"
        class="p-button-primary"></button>
    </ng-template>
  </p-dialog>

  <div>
    <div class="p-card-body">
      <p-table [value]="ui.invites" [tableStyle]="{'min-width': '50rem'}" responsiveLayout="scroll">
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'EMAIL' | translate }}</th>
            <th>{{ 'PERMISSION' | translate }}</th>
            <th>{{ 'STATUS' | translate }}</th>
            <th>{{ 'EXPIRY' | translate }}</th>
            <th style="width: 15rem">{{ 'ACTIONS' | translate }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-invite>
          <tr>
            <td>{{ invite.email }}</td>
            <td>
              <p-tag [value]="invite.permission_displayName || 'N/A'" severity="info"></p-tag>
            </td>
            <td>
              <p-tag [value]="invite.status || 'PENDING'"
                [severity]="invite.status === 'ACCEPTED' ? 'success' : 'warning'"></p-tag>
            </td>
            <td>{{ invite.expiresAt | dynamicDate:'short' }}</td>
            <td>
              <button pButton type="button" icon="pi pi-refresh" [label]="'RESEND' | translate"
                class="p-button-text mr-2" (click)="onResendInvite(invite.id)"
                pTooltip="{{'RESEND_INVITE' | translate}}" tooltipPosition="top"></button>
              <button pButton type="button" icon="pi pi-times-circle" [label]="'REVOKE' | translate"
                class="p-button-text mr-2" (click)="onRevokeInvite(invite.id, invite.email)"
                pTooltip="{{ 'REVOKE_INVITE' | translate }}" tooltipPosition="top"></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5" class="text-center py-4">{{ 'NO_PENDING_INVITES' | translate }}</td>
          </tr>
        </ng-template>
      </p-table>
      <div *ngIf="ui.error" class="p-message p-message-error mt-4">
        {{ ui.error }}
      </div>
    </div>
  </div>
</div>

<!-- Revoke Confirmation Dialog -->
<p-dialog header="{{ 'CONFIRM_REVOKE' | translate }}" [(visible)]="showRevokeConfirmDialog" [modal]="true"
  [style]="{width: '30vw'}" [draggable]="false" [resizable]="false">
  <p>{{ 'REVOKE_CONFIRM_MSG' | translate }} <strong>{{ pendingRevokeInviteEmail }}</strong>?</p>
  <p class="mt-2 text-sm text-gray-600">{{ 'REVOKE_CONFIRM_DETAIL' | translate }}</p>
  <ng-template pTemplate="footer">
    <button pButton type="button" [label]="'CANCEL' | translate" class="p-button-text"
      (click)="cancelRevoke()"></button>
    <button pButton type="button" [label]="'REVOKE_INVITE' | translate" class="p-button-warning"
      (click)="confirmRevoke()"></button>
  </ng-template>
</p-dialog>

<!-- Delete Confirmation Dialog -->
<!--
<p-dialog header="{{ 'CONFIRM_DELETE' | translate }}" [(visible)]="showDeleteConfirmDialog" [modal]="true" [style]="{width: '30vw'}" [draggable]="false" [resizable]="false">
  <p>{{ 'DELETE_CONFIRM_MSG' | translate }} <strong>{{ pendingDeleteInviteEmail }}</strong>?</p>
  <p class="mt-2 text-sm text-orange-500">{{ 'DELETE_CONFIRM_DETAIL' | translate }}</p>
  <ng-template pTemplate="footer">
    <button pButton type="button" [label]="'CANCEL' | translate" class="p-button-text" (click)="cancelDelete()"></button>
    <button pButton type="button" [label]="'DELETE_INVITE' | translate" class="p-button-danger" (click)="confirmDelete()"></button>
  </ng-template>
</p-dialog>
-->